export default "__VITE_ASSET__B2REDFNj__"